<template>
  <Chart class="sparkline" :options="chartOptions" />
</template>

<script>
import { Chart } from "highcharts-vue";
export default {
  components: {
    Chart,
  },
  props: {
    data: Array,
  },
  computed: {
    chartOptions() {
      const { data } = this;
      return {
        chart: {
          type: "spline",
          styledMode: true,
          margin: [0, 4, 0, 0],
        },
        credits: { enabled: false },
        title: { text: null },
        legend: { enabled: false },
        tooltip: { enabled: false },
        xAxis: {
          visible: false,
          title: { text: null },
          tickLength: 0,
          label: {
            padding: 0,
            enabled: true,
          },
        },
        yAxis: {
          visible: false,
          labels: { enabled: false },
          title: { text: null },
        },

        series: [
          {
            data: data.map((point, i, self) => ({
              y: point[1],
              x: point[0],
              marker: {
                enabled: i === self.length - 1 ? true : false,
                radius: 3,
              },
              // dataLabels: {
                // allowOverlap: false,
                // enabled: i === self.length - 1 ? true : false,
                // formatter: function () {
                //   return (
                //     this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") +
                //     " TJ"
                //   );
                // },
              // },
            })),
            colorIndex: 11,
          },
        ],
      };
    },
  },
};
</script>

<style>
.highcharts-background {
  fill: transparent;
}
.keyfigure-inner .sparkline {
  max-width: 200px;
  height: 64px;
  padding-top: 6px;
}
.highcharts-color-11 {
  fill: #04f;
  stroke: #04f;
}
</style>
